// extracted by mini-css-extract-plugin
module.exports = {"image":"Home_image__3oErR","container":"Home_container__2FYaN"};